<script setup>
import { ref, reactive, watch } from "vue";
import { useUserStore } from "@/stores/user";
import { usePatientStore } from "@/stores/patient";
import { useCrfStore } from "@/stores/crf";
import { useCommonStore } from "@/stores/common.js"
import { ElMessage } from "element-plus"
const crfStore = useCrfStore();
const emits = defineEmits(["create1"]);

const user = useUserStore();
// 对话框的显示状态
const dialogVisible = ref(false);

// 新患者的对象
const patient = reactive({});
const patientFormRef = ref();

// 身份证后六位输入规范化
watch(()=>patient['身份证后六位'], (newVal) => {
  if (newVal) {
    // 去除空格并转大写
    let formattedVal = newVal.trim().toUpperCase();
    // 只保留前6位字符
    formattedVal = formattedVal.substring(0, 6);
    // 只允许数字和X
    formattedVal = formattedVal.replace(/[^0-9X]/g, '');
    
    // 实时格式提示（不阻止输入，只在完整输入6位后验证）
    if (formattedVal.length === 6) {
      const validation = validateIdLast6Digits(formattedVal)
      if (!validation.valid) {
        // 使用更温和的提示，不阻止输入
        console.warn('身份证格式提示:', validation.message)
      }
    }
    
    patient['身份证后六位'] = formattedVal;
  }
});

// 身份证后6位格式验证（出生日期DD + 3位顺序码 + 1位校验码）
// 身份证18位结构：6位地址码 + 8位出生日期(YYYYMMDD) + 3位顺序码 + 1位校验码
// 后六位就是：DD(日期2位) + 顺序码(3位) + 校验码(1位)
function validateIdLast6Digits(idStr) {
  if (!idStr || idStr.length !== 6) {
    return { valid: false, message: '身份证后六位不能为空且必须为6位' };
  }
  
  // 提取各部分
  const day = parseInt(idStr.substring(0, 2)); // 出生日期的日(DD)
  const seqCode = idStr.substring(2, 5); // 3位顺序码
  const checkCode = idStr.charAt(5).toUpperCase(); // 校验码
  
  // 基本格式验证：日期(01-31) + 3位顺序码(000-999) + 校验码(0-9或X)
  const pattern = /^(0[1-9]|[12][0-9]|3[01])\d{3}[0-9X]$/i;
  if (!pattern.test(idStr)) {
    return { valid: false, message: '身份证后六位格式不正确（应为：日期2位+顺序码3位+校验码1位）' };
  }
  
  // 日期合理性验证（日期范围01-31）
  if (day < 1 || day > 31) {
    return { valid: false, message: '日期部分必须在01-31之间' };
  }
  
  // 验证顺序码是否为数字
  if (!/^\d{3}$/.test(seqCode)) {
    return { valid: false, message: '顺序码必须为3位数字' };
  }
  
  // 验证校验码格式
  if (!/^[0-9X]$/i.test(checkCode)) {
    return { valid: false, message: '校验码必须为数字0-9或字母X' };
  }
  
  return { valid: true, message: '' };
}

// 身份证验证（包含格式验证和重复性检查）
const idCard = async ()=>{
  let goOver = true
  let card = patient['身份证后六位']
  
  if (!card) {
    ElMessage.error('请输入身份证后六位')
    return false
  }
  
  // 格式验证
  const validation = validateIdLast6Digits(card)
  if (!validation.valid) {
    ElMessage.error(validation.message)
    return false
  }
  
  // 检查是否已存在
  try {
    let common = await useCommonStore().getIDcard("", patient['身份证后六位'], patient['患者姓名'])
    if (common.data?.isExists) {
      goOver = false
      ElMessage.error('该患者已存在')
    }
  } catch (error) {
    console.error('检查患者是否存在时出错:', error)
    ElMessage.error('验证失败，请稍后重试')
    return false
  }
  
  return goOver
}

// 手机号验证
const phone = (mobile)=>{

    let regu = /^1\d{10}$/;
    let re = new RegExp(regu);
    if (!re.test(mobile)){
        return false;
    }
    return true;
}
let phonediolag = ref(false)
let confirm = ref(false)

// 验证弹窗点击确认
const confirmdialog = ()=>{

  phonediolag.value = false
  confirm.value = true
  submitForm(patientFormRef.value)

}


// 提交上传中提示
let crfLoading = ref(false)

// 提交新患者
const submitForm = async (formEl) => {
  // console.log(formEl,"提交")
  if (!formEl) return;
  const patientStore = usePatientStore();
   formEl.validate(async (valid, fields) => {
    // console.log(valid,fields,"valid")
    if (valid) {
        //  手机号
       
        if(patient['患者联系方式']){
          if (phone(patient['患者联系方式']) || confirm.value) {
            // 直接提交
            confirm.value = true
            }else{
            // 提交中断(打开弹窗)
            phonediolag.value = true
            return
          }
        }
        if(!await idCard()) return;
        // return
        // 上传提示，开始提交
        crfLoading.value = true
        patientStore.create(patient).then((res) => {
          if (res.result === "success") {
            // 清空数据(有watch 置为null会报错)
            Object.keys(patient).forEach(e => {
              patient[`${e}`] = ''
            });
            crfLoading.value = false
              // console.log(res.data,"创建患者成功返回的数据");
            let data = JSON.stringify(res.data)
            setTimeout(() => {
              emits("create1", data);//参数基本数据类型  
            }, 800);
          
            dialogVisible.value = false;
            // 提交成功后清空手机号免验证
            confirm.value = false
          }
        });
 
    }
  });
};

function showDialog() {
  dialogVisible.value = true;
}
// (年龄) 肝活检-出生日期
const dataToString = (maxdate,mindate)=>{
    let YY = null
    let yy = null
  console.log(maxdate,mindate,"选择日期的变化");

    maxdate? YY = maxdate.getFullYear()-0 :YY = new Date().getFullYear()-0
    mindate? yy = mindate.getFullYear()-0 : yy = 0
   
    return mindate?YY-yy:0
}
// 监听出生日期选择
watch(()=>patient['生日'],(newval,oldval)=>{
  if (!dataToString(patient['入组时间'],newval)>=0) {
    patient['年龄'] =  dataToString(patient['入组时间'],newval)
  }else{
    mode.fields['生日'] = new Date(Date.now())
    ElMessage.error('入组时间应大于出生时间')
  }
})
// 监听入组(肝活检)时间选择
watch(()=>patient['入组时间'],(newval,oldval)=>{
  if (dataToString(newval,patient['生日'])>=0) {
    patient['年龄'] =  dataToString(newval,patient['生日'])
  }else{
    patient['入组时间'] = new Date(Date.now())
    ElMessage.error('入组时间应大于出生时间')
  }
  
});

// 监听体重输入是否规范
watch(()=>patient['体重'],(newval,oldval)=>{
  patient['体重'] =  newval.replace(/[^0-9]/g,'').replace(/^0\d$/,'0').slice(0,3) 
})
// 监听身高输入是否规范
watch(()=>patient['身高'],(newval,oldval)=>{
  // console.log(new RegExp(reg).test(newval))
  // console.log()
  patient['身高'] = newval.replace(/[^0-9]/g,'').replace(/^0\d$/,'0').slice(0,3) 
  // model.fields['身高'] =  newval.replace(/[^0-9]/g,'')
})

// 监听手机号输入是否规范
watch(()=>patient['患者联系方式'],(newval,oldval)=>{ 
  console.log(newval,"ipone")
  patient['患者联系方式'] = newval.replace(/[^0-9]/g,'').slice(0,11)
  
  
})

const disabledDate = (time) => {
  return time.getTime() > Date.now()
}
const screennew = reactive({
  size :'',
  rowWidth : '',
  colsapn :'',
  labelWidth : '',
  phonediolag:''
})


//  根据屏幕的大小设置弹窗和表格的大小
const watchWindowSize = ()=>{

// 获取窗口的宽度和高度，不包括滚动条
var w = document.documentElement.clientWidth;
var h = document.documentElement.clientHeight;
// 打印结果
// result.innerHTML = "宽: " + w + ", " + "高: " + h
// console.log(w,'wwwwwwwwwww')
if (w > 1000) {
  // 弹窗的宽度设置80% 否则100%
  screennew.size = 80
  screennew.rowWidth = 100
  screennew.colsapn= 15
  screennew.labelWidth = 250
  screennew.phonediolag = 30
}else{
  screennew.size = 100
  screennew.rowWidth = 120
  screennew.colsapn = 24
  screennew.labelWidth = 160
  screennew.phonediolag = 90

}
}
watchWindowSize()

window.onresize = ()=>{
  watchWindowSize()

}
// 窗口变化事件
window.onload = ()=>{
// watchWindowSize()
};
;
</script>

<template>
  <el-button v-if="user.role.length != 1 || !user.role.includes('2')"  @click="showDialog" class="btn-new-patient">增加新的患者（一般信息）</el-button>
  <el-drawer v-model="dialogVisible" title="增加新的患者（一般信息）"
             :close-on-click-modal="false" :close-on-press-escape="false"
             direction="rtl" :size="`${screennew.size}%`">
    <el-row v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中121"  :style="`width:${screennew.rowWidth}% ;overflow: auto;`">
      <el-col :span="screennew.colsapn">
      <el-form :model="patient" :rules="crfStore" size="default" label-position="left" :label-width="`${screennew.labelWidth}px`" ref="patientFormRef">
        <el-form-item label="患者姓名" prop="患者姓名"> 
          <!-- prop一定要和表单的字段一样 -->
          <el-input v-model="patient.患者姓名"></el-input>
          <!-- <el-input type="hidden" v-model="patient['访视地点（医院）']"></el-input> -->
        </el-form-item>
        <el-form-item label="身份证后六位" prop="身份证后六位" class="item__label">
          <!-- prop="身份证后六位" :rules="crfStore.textRules('身份证后六位',true,{ len: 6, message: '需要6位' })" -->
          <el-input v-model="patient.身份证后六位" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="性别">
         
          <el-radio-group v-model="patient.性别">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="年龄" prop="年龄"
                      :rules="crfStore.intNumberRules('年龄',true)">
          <el-input v-model.number="patient.年龄" autocomplete="off">
            <template #append>岁</template>
          </el-input>
        </el-form-item> -->
        <el-form-item  label="出生日期" prop="生日" class="age">
          <div class="content">
              <div class="block">
                <el-date-picker
                  v-model="patient.生日"
                  type="date"
                  placeholder="请选择出生日期"
                  :disabled-date="disabledDate"
                  size="default"
                />
              </div>
              <el-input v-model="patient.年龄" placeholder="null" autocomplete="off" class="date" :disabled="true">
                <template #append>岁</template>
              </el-input>
              <p class="tishi">年龄:出生日期到肝活检日期</p>
          </div>
        </el-form-item>
        <el-form-item label="民族" class="item__label">
          <el-input v-model="patient.民族"></el-input>
        </el-form-item>
        <el-form-item label="身高（CM）" class="item__label">
                      <!-- prop="身高"
                      :rules="crfStore.intNumberRules('身高',true)" -->
          <el-input v-model="patient.身高" autocomplete="off">
            <template #append>CM</template>
          </el-input>
        </el-form-item>
        <el-form-item label="体重（KG）"  class="item__label" >
          <!-- prop="体重"
                      :rules="crfStore.floatNumberRules('体重',true)" -->
          <el-input v-model="patient.体重" autocomplete="off">
            <template #append>KG</template>
          </el-input>
        </el-form-item>
        <el-form-item label="入组时间（肝活检日期）" class="item__label" >
                
              <div class="block">
              <el-date-picker
                v-model="patient.入组时间"
                type="date"
                placeholder="请选择入组时间"
                size="default"
              />
            </div>
        </el-form-item>
        <el-form-item label="患者联系方式" class="item__label">
          <el-input v-model="patient.患者联系方式"></el-input>
        </el-form-item>
        <el-form-item label="主诊医生" prop="主诊医生姓名"
        :rules="crfStore.textRules('主诊医生姓名',true)">
          <el-input v-model="patient['主诊医生姓名']"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    </el-row>
    <template #footer>
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button type="primary" @click="submitForm(patientFormRef)">确定</el-button>
    </template>
  </el-drawer>

  <!-- 手机号验证 -->
  <el-dialog
    v-model="phonediolag"
    title="提示"
    :width="`${screennew.phonediolag}%`"
  >
    <span>您输入的患者联系方式不是11位手机号码，请确认联系方式是否正确</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="phonediolag = false">我要修改</el-button>
        <el-button type="primary" @click="confirmdialog()">确认正确</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style scoped>
/* :prop="itemProp('访视日期')"
                  :rules="crfStore.textRules('访视日期',true)" */
.btn-new-patient {
    margin-bottom: 10px;
}

.item__label{
  line-height: 32px;
  :deep(.el-input__wrapper){
    margin-left: -11px;
  }
}
.item__label:before {
    content: "*";
    color: var(--el-color-danger);
    margin-right: 4px;
}
.age{
  .content{
    display: block;
  }
  .block{
    margin-bottom: 20px; 
  }
}
.date{
  width: 150px;
}
.tishi{
  margin: 0;
  color: silver;
  font-size: 12px;
}
</style>